import React, { Component } from 'react';
/* eslint-disable */
import axios from 'axios';
import { MY_API_URL } from '../../Apanel/QueryMe';
import Switch from 'react-switch';
import Ticketmsgs from '../../Apanel/Ticketmsgs';
import Select from 'react-select';
var dateFormat = require('dateformat');
import {
	Button,
	ButtonGroup,
	ButtonToolbar,
	Card,
	CardBody,
	Col,
	Badge,
	Table,
	Modal,
	FormGroup,
	Label,
	Input,
} from 'reactstrap';
import AccountOutlineIcon from 'mdi-react/AccountOutlineIcon';
import Alert from '../../../shared/components/Alert';
import ProfileImage from '../../Apanel/ProfileImage';
const apiurl = MY_API_URL;
const dimgurl = apiurl + 'ava.png';
const initialstate = {
	image: dimgurl,
	alltickets: [],
	showAlert: false,
	alertType: '',
	alertText: '',
	token: localStorage.token,
	title: '',
	description: '',
	rdescription: '',
	priority: 'low',
	showtickets: 1,
};
const priorityOptions = [
	{ value: 'high', label: 'High' },
	{ value: 'medium', label: 'Medium' },
	{ value: 'low', label: 'Low' },
];
class Mytickets extends Component {
	constructor(props) {
		super(props);
		this.handlePriorityChange = this.handlePriorityChange.bind(this);
	}
	state = { ...initialstate };
	componentDidMount() {
		this.handleGetTickets(localStorage.token);
	}
	handleChange = (event) => {
		const { name, value } = event.target;
		console.log(name + ' ' + value);
		this.setState({ [name]: value });
	};
	handlePriorityChange(event) {
		this.setState(
			{
				priority: event.value,
			},
			() => {
				console.log('priority', this.state.priority);
			},
		);
	}
	handleTicketChange(e1, e2) {
		this.setState(
			{
				showtickets: e1,
			},
			() => {
				console.log('showtickets', this.state.showtickets);
			},
		);
	}
	handleNewkey = () => {
		this.setState({
			addTicketModal: true,
		});
	};
	handleAkey(e1, e2, e3) {
		// console.log(e1, e2, e3);
		var lbl = 'Replyed by User';
		this.setState({
			rplTicketModal: true,
			prosticketid: e1,
			lbl: lbl,
			sts: e2,
		});
	}

	handleUserSubmit = (event) => {
		event.preventDefault();
		console.log(this.state.title);
		const headers = {
			'Content-Type': 'application/json',
			Authorization: localStorage.token,
		};

		const addticketurl = apiurl + 'addnewticket';
		var postData = {
			title: this.state.title,
			description: this.state.description,
			priority: this.state.priority,
			uid: localStorage.usercode,
		};
		axios
			.post(addticketurl, postData, {
				headers: headers,
			})
			.then((response) => {
				console.log(response.data.message);
				if (response.data.error) {
					this.setState({
						showAlert: true,
						alertType: 'warning',
						alertText: response.data.message,
					});
				} else {
					swal(this.state.title + ' Ticket ' + response.data.message, {
						icon: 'success',
					});
					this.setState(
						{
							addTicketModal: false,
							showAlert: false,
							title: '',
							description: '',
							priority: '',
						},
						() => {
							this.handleGetTickets(localStorage.token);
						},
					);
				}
			})
			.catch((error) => {
				console.log('Error is ', error);
				this.setState({
					alertType: 'danger',
					showAlert: true,
					alertText: 'Failed Try Again Later!',
				});
			});
	};
	handleCkey = () => {
		this.setState({
			addTicketModal: false,
			rplTicketModal: false,
		});
	};
	handleRplSubmit = (event) => {
		event.preventDefault();
		console.log(this.state.title);
		const headers = {
			'Content-Type': 'application/json',
			Authorization: localStorage.token,
		};

		const addticketurl = apiurl + 'replyticket';
		var postData = {
			description: this.state.rdescription,
			uid: localStorage.usercode,
			tid: this.state.prosticketid,
			lbl: this.state.lbl,
			sts: this.state.sts,
		};
		axios
			.post(addticketurl, postData, {
				headers: headers,
			})
			.then((response) => {
				console.log(response.data.message);
				if (response.data.error) {
					this.setState({
						showAlert: true,
						alertType: 'warning',
						alertText: response.data.message,
					});
				} else {
					swal(this.state.title + ' Ticket ' + response.data.message, {
						icon: 'success',
					});
					this.setState(
						{
							rplTicketModal: false,
							showAlert: false,
							prosticketid: '',
							lbl: '',
							sts: '',
						},
						() => {
							this.handleGetTickets(localStorage.token);
						},
					);
				}
			})
			.catch((error) => {
				console.log('Error is ', error);
				this.setState({
					alertType: 'danger',
					showAlert: true,
					alertText: 'Failed Try Again Later!',
				});
			});
	};

	handleTicket = (id, all) => {
		console.log(id);
		localStorage.setItem('ticketid', id);
		this.props.history.push('/viewticket', {
			ticketid: id,
		});
	};
	handleTkey = (id, ttitle, checked) => {
		// console.log(checked + 'checked');
		// console.log(id + 'id');
		// console.log(ttitle + 'ttitle');
		var keysts = checked == true ? 7 : 5;
		var kstatus = 'Close';
		var lbl = 'Closed by User';
		if (checked) {
			kstatus = 'Reopen';
			lbl = 'Reopened';
		}
		swal({
			title: kstatus + ' ' + ttitle,
			text: 'Are you sure?',
			icon: 'warning',
			buttons: true,
			dangerMode: true,
		}).then((keyconfirm) => {
			if (keyconfirm) {
				const headers = {
					'Content-Type': 'application/json',
					Authorization: localStorage.token,
				};

				const toticketurl = apiurl + 'togticket';
				var postData = {
					uid: localStorage.usercode,
					tid: id,
					sts: keysts,
					lbl: lbl,
				};
				axios
					.post(toticketurl, postData, {
						headers: headers,
					})
					.then((response) => {
						console.log(response.data.message);

						if (response.data.error) {
							swal(ttitle + ' ' + response.data.message, {
								icon: 'warning',
							});
						} else {
							this.handleGetTickets(localStorage.token);
							swal(ttitle + ' ' + response.data.message, {
								icon: 'success',
							});
						}
					})
					.catch((error) => {
						console.log('Error is ', error);
						swal('Try Again Later', {
							icon: 'Danger',
						});
					});
			}
		});
	};
	handleGetTickets = (token) => {
		const headers = {
			'Content-Type': 'application/json',
			Authorization: localStorage.token,
		};
		var postData = {
			token: token,
			uid: localStorage.usercode,
			status: 'all',
		};
		const getuurl = apiurl + 'getmytickets';
		axios
			.post(getuurl, postData, {
				headers: headers,
			})
			.then((response) => {
				if (response.data.error) {
				} else {
					this.setState({
						alltickets: [...response.data.data],
					});
				}
			})
			.catch((error) => {
				localStorage.clear();
				this.props.history.push('/');
			});
	};

	render() {
		const {
			email,
			addTicketModal,
			showObox,
			showCbox,
			showRbox,
			showAlert,
			alertType,
			alertText,
			newrole,
			domain,
			showtickets,
			title,
			description,
			rdescription,
			priority,
		} = this.state;
		return (
			<Col md={12}>
				<Card>
					<CardBody>
						<Table responsive hover>
							<thead>
								<tr>
									<th>
										<FormGroup check>
											<Label check>
												<Input
													type="radio"
													name="radio1"
													checked={showtickets == 1 ? 1 : 0}
													onChange={this.handleTicketChange.bind(this, 1)}
												/>{' '}
												New Tickets
											</Label>
										</FormGroup>
									</th>
									<th>
										<FormGroup check>
											<Label check>
												<Input
													type="radio"
													name="radio1"
													checked={showtickets == 7 ? 1 : 0}
													onChange={this.handleTicketChange.bind(this, 7)}
												/>{' '}
												Reopened
											</Label>
										</FormGroup>
									</th>
									<th>
										<FormGroup check>
											<Label check>
												<Input
													type="radio"
													name="radio1"
													checked={showtickets == 2 ? 1 : 0}
													onChange={this.handleTicketChange.bind(this, 2)}
												/>{' '}
												Under Process
											</Label>
										</FormGroup>
									</th>
									<th>
										<FormGroup check>
											<Label check>
												<Input
													type="radio"
													name="radio1"
													checked={showtickets == 3 ? 1 : 0}
													onChange={this.handleTicketChange.bind(this, 3)}
												/>{' '}
												Replyed by Support
											</Label>
										</FormGroup>
									</th>
									<th>
										<FormGroup check>
											<Label check>
												<Input
													type="radio"
													name="radio1"
													checked={showtickets == 4 ? 1 : 0}
													onChange={this.handleTicketChange.bind(this, 4)}
												/>{' '}
												Replyed
											</Label>
										</FormGroup>
									</th>
									<th>
										<FormGroup check>
											<Label check>
												<Input
													type="radio"
													name="radio1"
													checked={showtickets == 5 ? 1 : 0}
													onChange={this.handleTicketChange.bind(this, 5)}
												/>{' '}
												Closed
											</Label>
										</FormGroup>
									</th>
									<th>
										<Button
											className="float-right btn-sm addticket"
											color="success"
											onClick={this.handleNewkey}
										>
											+ New Ticket
										</Button>
									</th>
								</tr>
							</thead>
						</Table>
					</CardBody>
				</Card>
				{this.state.alltickets &&
					this.state.alltickets.map((ticket, index) => {
						var usts = true;
						if (ticket.status == 5 || ticket.status == 6) {
							usts = false;
						}
						if (ticket.status == showtickets) {
							return (
								<div className="panel panel--success card" key={index}>
									<div className="panel__body card-body">
										<div className="panel__title">
											<div className="panel__btns">
												{' '}
												{ticket.status == 3 || ticket.status == 7 ? (
													<Button
														className="float-right btn-sm addticket"
														color="success"
														onClick={this.handleAkey.bind(this, ticket.id, 4)}
													>
														+ Reply
													</Button>
												) : null}{' '}
												{ticket.status == 1 ||
												ticket.status == 3 ||
												ticket.status == 4 ||
												ticket.status == 5 ||
												ticket.status == 6 ||
												ticket.status == 7 ? (
													<Switch
														handleDiameter={10}
														height={15}
														checked={usts}
														onChange={this.handleTkey.bind(
															this,
															ticket.id,
															ticket.title,
														)}
													/>
												) : null}{' '}
											</div>

											<h5 className="bold-text">
												<strong
													className="ticketlable"
													style={{ fontSize: '16px' }}
												>
													{ticket.lable == 'New' ? (
														<Badge color={'danger'}>{ticket.lable}</Badge>
													) : null}
													{ticket.lable == 'Processing' ? (
														<Badge color={'primary'}>{ticket.lable}</Badge>
													) : null}
													{ticket.lable == 'Replyed by Support' ? (
														<Badge color={'success'}>{ticket.lable}</Badge>
													) : null}
													{ticket.lable == 'Replyed by User' ? (
														<Badge color={'warning'}>{ticket.lable}</Badge>
													) : null}
													{ticket.lable == 'Closed by User' ? (
														<Badge color={'success'}>{ticket.lable}</Badge>
													) : null}{' '}
													{ticket.lable == 'Closed by Support' ? (
														<Badge color={'success'}>{ticket.lable}</Badge>
													) : null}{' '}
													{ticket.lable == 'Reopened' ? (
														<Badge color={'danger'}>{ticket.lable}</Badge>
													) : null}{' '}
													{ticket.priority == 'high' ? (
														<Badge color={'danger'}>{ticket.priority}</Badge>
													) : null}
													{ticket.priority == 'medium' ? (
														<Badge color={'warning'}>{ticket.priority}</Badge>
													) : null}
													{ticket.priority == 'low' ? (
														<Badge color={'primary'}>{ticket.priority}</Badge>
													) : null}
												</strong>

												{ticket.title}
											</h5>
											<span className="profile__activity-date">
												Date: {dateFormat(ticket.createdon, 'd-m-yyyy')}
											</span>
										</div>
										<div className="collapse show">
											<div className="panel__content">
												<p className="typography-message">
													{ticket.description}
												</p>
											</div>
										</div>
										<Ticketmsgs ticketid={ticket.id} />
									</div>
								</div>
							);
						}
					})}

				<Modal
					isOpen={this.state.addTicketModal}
					modalClassName="ltr-support"
					className="modal-dialog--primary newt"
				>
					<div className="modal__header">
						<button
							className="lnr lnr-cross modal__close-btn"
							type="button"
							onClick={this.handleCkey}
						/>
						<h4 className="text-modal  modal__title">Add New Ticket</h4>
					</div>
					<div className="modal__body">
						{this.state.showAlert ? (
							<Alert color={this.state.alertType}>
								<p>{this.state.alertText}</p>
							</Alert>
						) : null}
						<form
							className="form"
							onSubmit={(event) => this.handleUserSubmit(event)}
						>
							<div className="form__form-group">
								<div className="form__form-group-field">
									<input
										name="title"
										type="text"
										placeholder="Enter Title"
										className="form-control"
										value={title}
										onChange={this.handleChange}
										required
									/>
								</div>
							</div>
							<div className="form__form-group">
								<div className="form__form-group-field">
									<textarea
										name="description"
										type="text"
										placeholder="Enter Description"
										className="form-control"
										value={description}
										onChange={this.handleChange}
										required
									/>
								</div>
							</div>
							<div className="form__form-group">
								<span className="form__form-group-label">Priority</span>
								<div className="form__form-group-field priority">
									<Select
										options={priorityOptions}
										onChange={this.handlePriorityChange}
										defaultValue={priority}
									/>
								</div>
							</div>
							<button
								className="btn btn-primary account__btn account__btn--small"
								type="submit"
							>
								Add Ticket
							</button>
						</form>
					</div>
				</Modal>
				<Modal
					isOpen={this.state.rplTicketModal}
					modalClassName="ltr-support"
					className="modal-dialog--primary newt"
				>
					<div className="modal__header">
						<button
							className="lnr lnr-cross modal__close-btn"
							type="button"
							onClick={this.handleCkey}
						/>
						<h4 className="text-modal  modal__title">Reply Ticket</h4>
					</div>
					<div className="modal__body">
						{this.state.showAlert ? (
							<Alert color={this.state.alertType}>
								<p>{this.state.alertText}</p>
							</Alert>
						) : null}
						<form
							className="form"
							onSubmit={(event) => this.handleRplSubmit(event)}
						>
							<div className="form__form-group">
								<div className="form__form-group-field">
									<textarea
										name="rdescription"
										type="text"
										placeholder="Enter Description"
										className="form-control"
										value={rdescription}
										onChange={this.handleChange}
										required
									/>
								</div>
							</div>

							<button
								className="btn btn-primary account__btn account__btn--small"
								type="submit"
							>
								Reply Ticket
							</button>
						</form>
					</div>
				</Modal>
			</Col>
		);
	}
}

export default Mytickets;
